import React, { Component } from 'react'
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column'
import {Button} from 'primereact/button';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactLoading from 'react-loading';
import { EcheancierLoyerService } from '../service/EcheancierLoyerService';
import { PaiementLoyerService } from '../service/PaiementLoyerService';
import { EtudiantService } from '../service/EtudiantService';
import { SessionService } from '../service/SessionService';
import { messageErreur } from '../service/MessageErreur';


/*
 * Écran étudiant : consulter son échéancier de l'année et payer ses échéances
 * via FASO ARZEKA.
 *
 * L'affichage est piloté par statutPaiement (PAYE / EN_COURS / IMPAYE) et par
 * payable, pas par paymentStatus qui n'est que le statut brut de la passerelle.
 * La caution doit être réglée avant toute autre échéance : le serveur le fait
 * respecter, payable le reflète côté écran.
 */
export class PaiementLoyer extends Component {

    constructor() {
        super();
        this.state = {
            echeancier : null,
            loading : false,
            indisponible : false,
            messageIndisponible : "",
            idEcheanceEnCours : null,
            quittanceEnCours : null
        }

        this.echeancierLoyerService = new EcheancierLoyerService();
        this.paiementLoyerService = new PaiementLoyerService();
        this.etudiantService = new EtudiantService();
        this.sessionService = new SessionService();

        this.loadEcheancier = this.loadEcheancier.bind(this);
        this.payer = this.payer.bind(this);
        this.telechargerQuittance = this.telechargerQuittance.bind(this);
        this.statutBodyTemplate = this.statutBodyTemplate.bind(this);
        this.dateLimiteBodyTemplate = this.dateLimiteBodyTemplate.bind(this);
        this.actionBodyTemplate = this.actionBodyTemplate.bind(this);
    }

    componentDidMount() {
        this.loadEcheancier();
    }

    /*
     * Deux identifiants sont nécessaires et aucun n'est directement dans le
     * localStorage : l'idEtudiant vient du profil (le "id" du login est celui
     * du compte utilisateur, pas de l'étudiant), l'idAnnee de la session en cours.
     */
    loadEcheancier() {
        const data = localStorage.getItem('user')
        const user = data ? JSON.parse(data) : {}
        if (!user.username) {
            this.setState({indisponible : true, messageIndisponible : "Session expirée : reconnectez-vous."});
            return;
        }
        this.setState({loading : true, indisponible : false});

        const requeteSession = user.idDirection
            ? this.sessionService.getSessionDirection(user.idDirection)
            : this.sessionService.getAll();

        Promise.all([
            this.etudiantService.getByIne(user.username),
            requeteSession
        ])
        .then(([etudiant, sessions]) => {
            const idEtudiant = etudiant ? etudiant.idEtudiant : null;
            const session = this.getSessionCourante(sessions);
            if (!idEtudiant) {
                throw this.erreurLocale("profil");
            }
            if (!session) {
                throw this.erreurLocale("session");
            }
            return this.echeancierLoyerService.getEcheancierAnnee(idEtudiant, session.idAnnee);
        })
        .then(echeancier => {
            this.setState({echeancier : echeancier, loading : false})
        })
        .catch(error => {
            console.log(error);
            if (error && error.origine === "profil") {
                this.echouer("Votre profil étudiant est introuvable. Contactez la cité.");
                return;
            }
            if (error && error.origine === "session") {
                this.echouer("Aucune session en cours n'a été trouvée.");
                return;
            }
            this.echouer(messageErreur(error, {
                404 : "Votre échéancier n'est pas encore disponible. Il est créé dès que votre lit est affecté.",
                403 : "Vous n'avez pas accès à cet échéancier. Reconnectez-vous, puis contactez la cité si le problème persiste."
            }));
        })
    }
    /* Erreur de préparation (hors réponse HTTP), distinguée dans le catch. */
    erreurLocale(origine) {
        const erreur = new Error(origine);
        erreur.origine = origine;
        return erreur;
    }
    echouer(message) {
        this.setState({echeancier : null, indisponible : true, messageIndisponible : message, loading : false});
    }
    /* Session ouverte en priorité, sinon la plus récente. */
    getSessionCourante(sessions) {
        const liste = Array.isArray(sessions) ? sessions : [];
        if (!liste.length) {
            return null;
        }
        const ouverte = liste.find(session => session.statutSession === "OUVERT");
        if (ouverte) {
            return ouverte;
        }
        return liste.reduce((max, session) => session.idAnnee > max.idAnnee ? session : max);
    }

    /* URL de retour du navigateur après paiement (routage par hash). */
    getCallbackUrl() {
        return window.location.origin + window.location.pathname + '#/paiement-retour';
    }

    payer(echeance) {
        this.setState({idEcheanceEnCours : echeance.idEcheanceLoyer});
        this.paiementLoyerService.initier(echeance.idEcheanceLoyer, this.getCallbackUrl()).then(paiement => {
            if (paiement.alreadyPaid) {
                this.notify("Cette échéance est déjà payée.");
                this.setState({idEcheanceEnCours : null});
                this.loadEcheancier();
                return;
            }
            if (!paiement.paymentUrl) {
                this.notify2("Le lien de paiement n'a pas été fourni par la passerelle.");
                this.setState({idEcheanceEnCours : null});
                return;
            }
            // la page de retour a besoin de savoir quelle échéance interroger
            localStorage.setItem('idEcheanceEnCours', JSON.stringify(echeance.idEcheanceLoyer));
            window.location.href = paiement.paymentUrl;
        })
        .catch(error => {
            console.log(error);
            this.notify2(messageErreur(error, {
                409 : "La caution doit être payée avant les autres échéances.",
                400 : "Paiement refusé : montant ou échéance invalide.",
                404 : "Échéance introuvable."
            }));
            this.setState({idEcheanceEnCours : null});
        })
    }

    telechargerQuittance(echeance) {
        this.setState({quittanceEnCours : echeance.idEcheanceLoyer});
        this.paiementLoyerService.getQuittancePdf(echeance.idEcheanceLoyer).then(fichier => {
            const url = window.URL.createObjectURL(new Blob([fichier], {type : 'application/pdf'}));
            const lien = document.createElement('a');
            lien.href = url;
            lien.setAttribute('download', 'quittance-' + echeance.idEcheanceLoyer + '.pdf');
            document.body.appendChild(lien);
            lien.click();
            lien.parentNode.removeChild(lien);
            window.URL.revokeObjectURL(url);
            this.setState({quittanceEnCours : null});
        })
        .catch(error => {
            console.log(error);
            this.notify2(messageErreur(error, {
                409 : "La quittance n'est disponible qu'une fois le paiement validé."
            }));
            this.setState({quittanceEnCours : null});
        })
    }

    libelleTypeEcheance(typeEcheance) {
        if (typeEcheance === "CAUTION") return "Caution";
        if (typeEcheance === "PREMIER_VERSEMENT") return "1er versement";
        if (typeEcheance === "RESTE") return "Reste du loyer";
        return typeEcheance;
    }
    /* Les dates arrivent en dd-MM-yyyy. */
    parseDate(date) {
        if (!date) {
            return null;
        }
        const morceaux = String(date).split('-');
        if (morceaux.length !== 3) {
            return null;
        }
        return new Date(parseInt(morceaux[2]), parseInt(morceaux[1]) - 1, parseInt(morceaux[0]));
    }
    estEnRetard(echeance) {
        if (echeance.statutPaiement === "PAYE") {
            return false;
        }
        const limite = this.parseDate(echeance.dateLimite);
        if (!limite) {
            return false;
        }
        const aujourdhui = new Date();
        aujourdhui.setHours(0, 0, 0, 0);
        return limite < aujourdhui;
    }

    formatMontant = (valeur) => Number(valeur).toLocaleString('fr-FR') + " FCFA";
    typeBodyTemplate = (rowData) => <span>{this.libelleTypeEcheance(rowData.typeEcheance)}</span>;
    montantBodyTemplate = (rowData) => <span>{this.formatMontant(rowData.montant)}</span>;
    moisBodyTemplate = (rowData) => <span>{rowData.nombreMois} mois</span>;

    dateLimiteBodyTemplate(rowData) {
        if (!rowData.dateLimite) {
            return <span></span>;
        }
        return <span>{String(rowData.dateLimite).replace(/-/g, '/')}</span>;
    }

    statutBodyTemplate(rowData) {
        const statut = rowData.statutPaiement;
        if (statut === "PAYE") {
            return <span style={{color : "green", fontWeight : "bold"}}>Payé</span>;
        }
        if (statut === "EN_COURS") {
            return <span style={{color : "#b58900"}}>En cours</span>;
        }
        if (this.estEnRetard(rowData)) {
            return (
                <span>
                    <span style={{color : "red", fontWeight : "bold"}}>En retard</span>
                </span>
            );
        }
        return <span>À payer</span>;
    }

    actionBodyTemplate(rowData) {
        const statut = rowData.statutPaiement;
        if (statut === "PAYE") {
            if (!rowData.quittanceDisponible) {
                return <span><i className="pi pi-check" style={{color : "green"}}></i></span>;
            }
            return <Button type="button" label="Quittance" icon="pi pi-download" className="p-button-secondary"
                           disabled={this.state.quittanceEnCours === rowData.idEcheanceLoyer}
                           onClick={() => this.telechargerQuittance(rowData)} />;
        }
        const enCours = this.state.idEcheanceEnCours === rowData.idEcheanceLoyer;
        if (statut === "EN_COURS") {
            return <Button type="button" label="Reprendre" icon="pi pi-credit-card" disabled={enCours}
                           onClick={() => this.payer(rowData)} />;
        }
        if (!rowData.payable) {
            return <span style={{color : "#888"}}>Payez d'abord la caution</span>;
        }
        return <Button type="button" label="Payer" icon="pi pi-credit-card" className="p-button-success"
                       disabled={enCours} onClick={() => this.payer(rowData)} />;
    }

    notify = (message) => toast.success(message || 'Opération réussie !', {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });
    notify2 = (message) => toast.error(message || "Echec de l'opération !", {
            position: "top-right",
            autoClose: 10000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        })
    loadingSpinner = ( type, color) => (
        <ReactLoading type={type} color={color} height={200} width={50} />
    )

    /* Totaux calculés par le serveur : on ne les recalcule pas côté écran. */
    renderResume() {
        const echeancier = this.state.echeancier;
        return (
            <p>
                Cité : <b>{echeancier.nomCite}</b> &nbsp;|&nbsp;
                Loyer mensuel : <b>{this.formatMontant(echeancier.montantMensuel)}</b><br/>
                Total à payer : <b>{this.formatMontant(echeancier.montantTotal)}</b> &nbsp;|&nbsp;
                Déjà payé : <b style={{color : "green"}}>{this.formatMontant(echeancier.montantPaye)}</b> &nbsp;|&nbsp;
                Reste : <b style={{color : echeancier.resteAPayer > 0 ? "red" : "green"}}>{this.formatMontant(echeancier.resteAPayer)}</b>
            </p>
        );
    }

    render() {
        return (
            <div className="p-grid">
                <div className="p-col-12">
                    <div className="card card-w-title">
                    <ToastContainer
                        position="top-right"
                        autoClose={3000}
                        hideProgressBar={false}
                        newestOnTop={false}
                        closeOnClick
                        rtl={false}
                        pauseOnFocusLoss
                        draggable
                        pauseOnHover
                    />
                        <h1>Paiement du loyer</h1>
                        <Button label="Rafraichir" icon="pi pi-refresh" style={{width : "150px", marginBottom : "10px"}} onClick={this.loadEcheancier} />

                        {this.state.loading ?
                            <div className="p-grid">
                                <div className="p-col-6"></div>
                                <div className="p-col-6">{this.loadingSpinner("spin","black")}</div>
                            </div>
                        : this.state.indisponible || !this.state.echeancier ?
                            <p>{this.state.messageIndisponible || "Aucun échéancier de loyer n'est disponible pour le moment."}</p>
                        :
                            <div>
                                {this.renderResume()}
                                <DataTable value={this.state.echeancier.echeances || []} responsive={true}>
                                    <Column field="ordre" header="N°" style={{width : '4em'}}/>
                                    <Column field="typeEcheance" header="Type" body={this.typeBodyTemplate}/>
                                    <Column field="nombreMois" header="Durée" body={this.moisBodyTemplate}/>
                                    <Column field="montant" header="Montant" body={this.montantBodyTemplate}/>
                                    <Column field="dateLimite" header="Date limite" body={this.dateLimiteBodyTemplate}/>
                                    <Column field="statutPaiement" header="Statut" body={this.statutBodyTemplate}/>
                                    <Column header="" body={this.actionBodyTemplate} style={{textAlign:'center', width: '14em'}}/>
                                </DataTable>
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default PaiementLoyer
